import { Serializable } from '../../../../_shared/model/deserialize.service';
import { DocumentData } from './document-data.model';

export class WebSocketChat implements Serializable<WebSocketChat> {
    eventTime: number;
    message: string;
    chat: string;
    source: string;
    document: DocumentData;
    username: string;

    deserialize(input) {
        this.eventTime = input.eventTime;
        this.message = input.message;
        this.chat = input.chat;
        this.source = input.source;
        this.document = input.document;
        this.username = input.username;
        return this;
    }
}
